import resourcesToBackend from 'i18next-resources-to-backend'

export const initResourcesToBackEnd = () => {
  return resourcesToBackend(
    (language: string, namespace: string) =>
      import(`../locales/${language}/${namespace}.json`)
  )
}
